import { render, staticRenderFns } from "./CountStores.vue?vue&type=template&id=37413be2&scoped=true&"
import script from "./CountStores.vue?vue&type=script&lang=js&"
export * from "./CountStores.vue?vue&type=script&lang=js&"
import style0 from "./CountStores.vue?vue&type=style&index=0&id=37413be2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37413be2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
